const L="NEXT_LOCALE",t=31536e3,E="strict",c="X-NEXT-INTL-LOCALE",e="locale";export{L as COOKIE_LOCALE_NAME,t as COOKIE_MAX_AGE,E as COOKIE_SAME_SITE,c as HEADER_LOCALE_NAME,e as LOCALE_SEGMENT_NAME};
